export enum AppEnums {
  si = 'Si',
  no = 'No',
  ok = 'Ok',
  cancelar = 'Cancelar',
  acpetar = 'Aceptar',
  crear = 'Crear',
}